<template>
  <div>
    <TitleField
      fieldName="isTrustee"
      :fieldGroup="getTrusteeFieldGroup(role)"
    />
    <TrusteeSection :data="trusteeInfoBase || assigneeBase" documents-hidden />

    <v-row>
      <v-col cols="6">
        <v-text-field
          v-model="$v.trusteeForm.trusteeStatus.$model"
          :errorMessages="getValidationErrorText($v.trusteeForm.trusteeStatus)"
          label="Должность или статус представителя (при наличии)"
          outlined
        />
      </v-col>
    </v-row>

    <StatusDocument :v="$v.trusteeForm.documents.statusDocument" />
    <AuthorityDocument :v="$v.trusteeForm.documents.authorityDocument" />

    <slot name="footer" :next="nextHandler"></slot>
  </div>
</template>

<script>
import TitleField from '@/components/elements/statement/FullStatementView/base/TitleField';
import TrusteeSection from '@/components/elements/statement/FullStatementView/elements/Trustee';
import StatusDocument, {
  statusDocumentModel,
  getStatusDocumentValidation,
} from '@/components/services/elements/StatusDocument';
import AuthorityDocument, {
  authorityDocumentModel,
  authorityDocumentValidation,
} from '@/components/services/elements/AuthorityDocument';
import deepmerge from 'deepmerge';
import cloneDeep from 'clone-deep';
import { getValidationErrorText } from '@/utils/validate';
import { getTrusteeFieldGroup } from '@/utils/common';

export default {
  name: 'DefaultTrustee',
  props: {
    addStatement: {
      type: Object,
      required: true,
    },
    role: {
      type: String,
      required: true,
    },
  },
  components: {
    TitleField,
    TrusteeSection,
    StatusDocument,
    AuthorityDocument,
  },
  data() {
    return {
      getTrusteeFieldGroup,
      getValidationErrorText,
      trusteeForm: {
        trusteeStatus: '',
        documents: {
          statusDocument: cloneDeep(statusDocumentModel),
          authorityDocument: cloneDeep(authorityDocumentModel),
        },
      },
    };
  },
  validations() {
    return {
      trusteeForm: {
        trusteeStatus: {},
        documents: {
          statusDocument: getStatusDocumentValidation(
            this.trusteeForm,
            Boolean(this.assignee)
          ),
          authorityDocument: authorityDocumentValidation,
        },
      },
    };
  },
  computed: {
    trusteeInfo() {
      return this.addStatement.applicant[this.role].trusteeInfo;
    },

    trusteeInfoBase() {
      if (this.trusteeInfo) {
        const trustee = cloneDeep(this.trusteeInfo);
        delete trustee.trusteeStatus;
        return trustee;
      }

      return undefined;
    },

    assignee() {
      return this.addStatement.applicant[this.role].assignee;
    },

    assigneeBase() {
      if (this.assignee) {
        return {
          firstName: this.assignee.name,
          lastName: this.assignee.lastName,
          patronymic: this.assignee.patronymic,
          snils: this.assignee.snils,
          inn: this.assignee.inn,
          phone: this.assignee.phone,
          email: this.assignee.email,
        };
      }

      return undefined;
    },
  },
  async created() {
    if (this.trusteeInfo || this.assignee) this.prefillDraft();
  },
  methods: {
    prefillDraft() {
      if (this.trusteeInfo) {
        this.trusteeForm = deepmerge(this.trusteeForm, this.trusteeInfo);
        return;
      }

      this.trusteeForm = deepmerge.all([
        this.trusteeForm,
        this.assignee,
        {
          trusteeStatus: this.assignee.status,
        },
      ]);
    },

    assemblyModel() {
      if (this.trusteeInfo) {
        return cloneDeep({
          trusteeInfo: {
            ...this.trusteeInfoBase,
            ...this.trusteeForm,
          },
        });
      }

      return cloneDeep({
        assignee: {
          ...this.assigneeBase,
          status: this.trusteeForm.trusteeStatus,
          documents: cloneDeep(this.trusteeForm.documents),
        },
      });
    },

    async nextHandler() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        await this.$vuetify.goTo('#header-target', { duration: 200 });
        return;
      }

      this.$emit('send', this.trusteeForm);
    },
  },
};
</script>
